module.exports = __webpack_public_path__ + "static/media/LeftBuActive.4d9a65d9.svg";